<!--
* @description  参数1
* @fileName  byFold
* @author userName
* @date 2024-01-19 17:35:17
!-->
<template>
  <div id="byFold" class="byFold">
    <div class="list-main">
      <div v-for="(item,index) in list" :key="index" class="list-bj">
        <div :class="['list-item',{'orange':item.isTrue,'black':!item.isTrue}]" @click="clkxShow(item,index)">
          <span class="item-name">{{ item.name }}</span> <i :class="{ 'el-icon-arrow-down': !item.isTrue, 'el-icon-arrow-up': item.isTrue}" />
        </div>
        <div v-if="item.isTrue" class="list-card">
          <template v-for="(childItem,i) in item.child">
            <div v-if="!childItem.isHide" :key="i" :class="childItem.isActive ? 'active-class':'default-class'">
              <img :src="require(childItem.isFinish?'../../assets/img/manage/ic_xd_active.png':'../../assets/img/manage/ic_xd_normal.png')" width="12px" height="12px">
              <span @click="getActive(childItem,i)">{{ childItem.name }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ByFold',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    clkxShow(item, index) {
      this.$emit('isOpen', item, index)
    },
    getActive(item, i) {
      this.$emit('getActive', item, i)
    }
  }
}
</script>
<style scoped lang='scss'>
.byFold{
    .list-main{
        padding: 0;
        margin: 0;
        border-radius: 8px;
        div:first-child{
            border-radius: 8px 8px 0 0;
        }
        div:last-child{
            border-radius: 0px 0px 8px 8px;
        }
        .list-bj{
            width: 180px;
            //height: 160px;
            background: #FFFFFF;
            //border-radius: 8px;
            border: 1px solid rgba(233,85,6,0);
            //margin: 8px 0;
            overflow: hidden;cursor: pointer;
            .list-item{
                width: 162px;
                height: 48px;
                background: #FFFFFF;
                border-radius: 8px;
                border: 1px solid rgba(233,85,6,0);
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 8px;
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;

            }
            .orange{
                color: #E95506;
            }
            .black{
                color: #333333;
            }
            .item-name::before{
                    content: "" !important;
                    position: relative;
                    top: -3px;
                    display: inline-block;
                    width: 4px;
                    height: 4px;
                    background: #E95506;
                    border-radius: 50%;
                    margin-right: 8px;
            }
            .list-card{
                background: rgba(51,51,51,0.03);
                padding-top: 4px;
                .default-class{
                    margin: 0px 8px;
                    width: 164px;
                    height: 32px;
                    font-size: 13px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 32px;
                    display: flex;
                    align-items: center;
                    img{
                      margin:0 4px;
                    }
                }
                .active-class{
                    margin: 0px 8px;
                    width: 164px;
                    height: 32px;
                    background: rgba(237,119,56,0.08);
                    border-radius: 8px;
                    font-size: 13px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #E95506;
                    line-height: 32px;
                    display: flex;
                    align-items: center;
                    img{
                      margin:0 4px;
                    }
                }
            }
        }
    }
}
</style>
